import * as React from 'react'
import { withRouter } from 'next/router'
import { config } from 'react-awesome-styled-grid'
import { connect } from 'react-redux'
import styled from 'styled-components'
import type { Dispatch } from 'redux'
import Footer from '@components/Footer'
import HtmlHead from '@components/HtmlHead'
import TopNav from '@components/TopNav'
import TopNavMobile from '@components/TopNavMobile'
import Faqs from '@components/gift/Faqs'
import GiftContentUniverse from '@components/gift/GiftContentUniverse'
import GiftHeader from '@components/gift/GiftHeader'
import QuotesAndDownloadSection from '@components/gift/QuotesAndDownloadSection'
import { CTAPrimary, CTASecondary, GlobalStyle } from '@components/shared'
import FadeInContent from '@components/shared/FadeInContent'
import { colors } from '@components/shared/colors'
import { LinkWithUtms } from '../../actions/navigationActions'
import {
  ANNUAL_25_OFF_PRICE_STRING,
  ANNUAL_50_OFF_PRICE_STRING,
  ANNUAL_PRICE_STRING,
  SIX_MONTHS_25_OFF_PRICE_STRING,
  SIX_MONTHS_50_OFF_PRICE_STRING,
  SIX_MONTHS_PRICE_STRING
} from '../../helpers/subscriptionHelpers'
import type { AppStateType } from '../../reducers/appstate'

function Gift (props: {
  featureValentinesGift: boolean,
  featurePrideGift: boolean
}): React.ReactNode {
  const [isLoaded, setIsLoaded] = React.useState<boolean>(false)

  let htmlTitle = 'Dipsea | Share the spice'
  const htmlDescription =
    'Unlock our universe of pleasure and self-exploration for your BFF or lover.'

  if (props.featurePrideGift) {
    htmlTitle = 'Dipsea | The Perfectly Sexy Gift For Pride'
  } else if (props.featureValentinesGift) {
    htmlTitle = 'Dipsea | The Perfectly Sexy Valentines Day Gift'
  }

  let headerText = `Share the spice`
  const descriptionText = `Unlock our universe of pleasure and self-exploration for your BFF or lover..`

  let yearlyHref = `/gift/checkout`
  let yearlyCtaText = `Gift One Year - ${ANNUAL_PRICE_STRING}`
  let sixMonthsHref = `/gift/checkout?length=six`
  let sixMonthsCtaText = `Gift 6 months - ${SIX_MONTHS_PRICE_STRING}`

  if (props.featurePrideGift) {
    headerText = `Give Them a New Way to\n Celebrate Pride for <span>50% Off<span/>`
    yearlyHref = `/gift/checkout?promo=pride2023`
    yearlyCtaText = `Gift One Year - ${ANNUAL_50_OFF_PRICE_STRING} <span>${ANNUAL_PRICE_STRING}</span>`
    sixMonthsHref = `/gift/checkout?length=six&promo=pride2023-6`
    sixMonthsCtaText = `Gift 6 months - ${SIX_MONTHS_50_OFF_PRICE_STRING} <span>${SIX_MONTHS_PRICE_STRING}</span>`
  } else if (props.featureValentinesGift) {
    headerText = `Give Them a Valentines\nDay Treat for <span>25% Off<span/>`
    yearlyHref = `/gift/checkout?promo=valentine`
    yearlyCtaText = `Gift One Year - ${ANNUAL_25_OFF_PRICE_STRING} <span>${ANNUAL_PRICE_STRING}</span>`
    sixMonthsHref = `/gift/checkout?length=six&promo=valentine6`
    sixMonthsCtaText = `Gift 6 months - ${SIX_MONTHS_25_OFF_PRICE_STRING} <span>${SIX_MONTHS_PRICE_STRING}</span>`
  }

  const cta = (
    <>
      <CtaContainer>
        <LinkWithUtms pathname={yearlyHref}>
          <OrangeCta dangerouslySetInnerHTML={{ __html: yearlyCtaText }} />
        </LinkWithUtms>

        <LinkWithUtms pathname={sixMonthsHref}>
          <SandCta
            color={colors.sand}
            dangerouslySetInnerHTML={{ __html: sixMonthsCtaText }}
          />
        </LinkWithUtms>
      </CtaContainer>
    </>
  )

  return (
    <>
      <HtmlHead title={htmlTitle} description={htmlDescription} />

      <GlobalStyle backgroundColor={colors.midnightBlue} />
      <TopNavMobile
        backgroundColor={colors.midnightBlue95}
        isAssetLoaded={isLoaded}
      />
      <TopNav
        backgroundColor={colors.midnightBlue95}
        isAssetLoaded={isLoaded}
      />
      <GiftHeader
        loaded={(): void => setIsLoaded(true)}
        headerText={headerText}
        descriptionText={descriptionText}
        cta={cta}
      />

      {isLoaded && (
        <>
          <FadeInContent>
            <GiftContentUniverse cta={cta} />
          </FadeInContent>
          <FadeInContent>
            <Faqs />
          </FadeInContent>
          <FadeInContent>
            <QuotesAndDownloadSection />
          </FadeInContent>
        </>
      )}

      {isLoaded && <Footer backgroundColor={colors.midnightBlue} />}
    </>
  )
}

const mapStateToProps = (state: AppStateType): { featureValentinesGift: any, featurePrideGift: any } => {
  return {
    featureValentinesGift: state.featureValentinesGift,
    featurePrideGift: state.featurePrideGift
  }
}

const mapDispatchToProps = (_dispatch: Dispatch<any>): any => {
  return {}
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Gift) as any) as any

const CtaContainer = styled.div<any>`
  text-align: center;
  button {
    margin: 0 0 16px;
    width: 100%;
    height: unset;
  }

  ${(props: any): any => config(props).media.sm`
    button {
      width: unset;
      margin: 0 12.5px 16px;
    };
  `}
`
const OrangeCta = styled(CTAPrimary)<any>`
  min-width: 280px;
  span {
    text-decoration: line-through;
    color: ${colors.white70};
  }
`

const SandCta = styled(CTASecondary)<any>`
  min-width: 280px;
  span {
    text-decoration: line-through;
    color: ${colors.sand70};
  }
  :hover,
  :focus {
    transition: all 0.3s;
    span {
      color: ${colors.midnightBlue70};
    }
  }
`
